import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { RichTextViewComponent } from 'libs/shared/feature-rich-text-view/src/lib/rich-text-view.component';

import { NodeDetailPopoverDescription, TimeSpanType } from '@treetop/shared/model';

@Component({
  selector: 'tt-node-detail-popover-description',
  standalone: true,
  imports: [TranslocoModule, RichTextViewComponent],
  templateUrl: './node-detail-popover-description.component.html',
  styleUrl: './node-detail-popover-description.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NodeDetailPopoverDescriptionComponent {
  @HostBinding('class.node-detail-popover-description') nodeDetailPopoverDescription = true;

  @Input() description: NodeDetailPopoverDescription;
  protected readonly TimeSpanType = TimeSpanType;
}
